<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" template=" <img src='assets/images/spinner.gif' />"></ngx-spinner>
<div dir="{{languageDir}}">
  <div>
    <div class="content-top-box ">
      <app-bread-crumb></app-bread-crumb>
    </div>
    <mat-card-title class="mat-card-title Headingmain">{{langObj ? langObj?.QualityCheckBox : ('QualityCheckBox' |
      translate)}}</mat-card-title>
  </div>

  <mat-card>
    <div>
      <form [formGroup]="warehouseForm">
        <div style="display: flex;">
          <div style="width: 100%;">
            <div class="content-top-row ">
              <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-filed-rem-item"
                style="margin:0">
                <mat-label class="placeholder-title">{{langObj ? langObj?.Item : ('Item' | translate)}}</mat-label>
                <mat-select formControlName="item" panelClass="testClass" name="Group"
                  (selectionChange)="ItemChange($event,'itemCode')">
                  <mat-select-filter [placeholder]="'Search'" [displayMember]="'ItemCode'" [array]="itemInfoList"
                    (filteredReturn)="filteredItemInfoList = $event">
                  </mat-select-filter>
                  <mat-option *ngFor="let item of filteredItemInfoList" [value]="item.ItemCode">
                    {{ item?.ItemCode }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field class="top-row-first-filed-item top-row-filed-rem-item">
                <mat-label class="placeholder-title">{{langObj ? langObj?.ItemDescription : ('ItemDescription' |
                  translate)}}</mat-label>
                <mat-select formControlName="itemDesc" panelClass="testClass" name="Group" (openedChange)="openpanel()"
                  (selectionChange)="ItemChange($event,'ItemDesc')">
                  <mat-select-filter [placeholder]="'Search'" (input)="filterItemDescriptions($event)"
                    [displayMember]="'ItemDesc'" [array]="ItemDescList"
                    (filteredReturn)="filteredItemDescList = $event"></mat-select-filter>
                  <mat-option *ngFor="let itemDesc of filteredItemDescList" [value]="itemDesc">
                    {{ itemDesc }}
                  </mat-option>
                </mat-select>
              </mat-form-field>


              <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-filed-rem-item">
                <mat-label class="placeholder-title">{{langObj ? langObj?.ProcessOrder : ('ProcessOrder' |
                  translate)}}</mat-label>
                <mat-select formControlName="procOrder" panelClass="testClass" name="Group"
                  (selectionChange)="ProcessOrderChange($event)">
                  <mat-select-filter [placeholder]="'Search'" [displayMember]="'TypeName'" [array]="processOrderList"
                    (filteredReturn)="filteredProcessOrderList = $event">
                  </mat-select-filter>
                  <mat-option *ngFor="let order of filteredProcessOrderList" [value]="order.TypeId">
                    {{ order?.TypeName }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>

        <div style="display: flex;justify-content: space-between;">
          <div style="display: flex;width: 50%;justify-content: space-between;align-items: baseline;">
            <div class="content-top-row ">
              <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-filed-rem-item"
                style="margin:0;width:100%">
                <mat-label class="placeholder-title">{{langObj ? langObj?.ScanBatchNo : ('ScanBatchNo' |
                  translate)}}</mat-label>
                <input matInput (keyup.enter)="scanBatchNo()" formControlName="scantBatchNo" name="scantBatchNo" />
              </mat-form-field>
            </div>
            <div style="display: flex;width: 50%;justify-content: end;">
              <button type="button" mat-raised-button color="warn"
                style="background-color: #0f0fd1;font-size: 14px!important;margin-right: 7px;"
                (click)="MoveBatchInfoDataSource()">
                <span style="font-size: 12px;color: white;">{{langObj ? langObj?.MoveAll : ('MoveAll' |
                  translate)}}</span>
              </button>
              <button type="button" mat-raised-button color="warn" style="background-color: #0f0fd1;font-size: 14px;"
                (click)="clearBatchInfoDataDataNew()"><span style="font-size: 12px;color: white;">
                  {{langObj ? langObj?.ClearAll : ('ClearAll' | translate)}}
                </span></button>
            </div>
          </div>
          <div style="margin-right: 10px;">
            <div class="content-top-row ">
              <div class="p-grid p-fluid" style="text-align: end;">
                <div style="margin-top: 15px;">
                </div>
                <div style="margin-left: 10px;margin-top: 15px;">
                  <button type="button" mat-raised-button color="warn"
                    style="background-color: #0f0fd1;font-size: 14px;" (click)="clearBatchInfoDataData()"><span
                      style="font-size: 12px;color: white;">
                      {{langObj ? langObj?.ClearAll : ('ClearAll' | translate)}}
                    </span></button>
                </div>
              </div>
            </div>
          </div>
        </div>

      </form>
    </div>
    <mat-card-content>
      <div class="p-grid p-fluid">
        <div class="p-col-12 p-md-6 p-lg-6">
          <h3 class="mat-card-title Headingmain"> {{langObj ? langObj?.BatchInfo : ('BatchInfo' | translate)}}</h3>
          <mat-card>
            <div class="p-grid p-fluid">
              <div class="p-col-1 p-md-6 p-lg-6">
              </div>
            </div>
            <ag-grid-angular style="width: 100%; height: 24vw;" class="ag-theme-alpine" [rowData]="tempBatchInfoRowData"
              [columnDefs]="batchInfoColumnDefs" (gridReady)="batchInfoGridReady($event)"
              (rowClicked)="updatehighlight($event)" [frameworkComponents]="frameworkComponents"
              [gridOptions]="batchInfoGridOptions" [pagination]="true" [paginationPageSize]="10">
            </ag-grid-angular>
          </mat-card>
        </div>
        <div class="p-col-12 p-md-6 p-lg-6">
          <h2 class="mat-card-title Headingmain">{{langObj ? langObj?.SelectedBatchInfo : ('SelectedBatchInfo' |
            translate)}}</h2>
          <mat-card>
            <div class="p-grid p-fluid">
              <div class="p-col-1 p-md-6 p-lg-6">
              </div>
            </div>
            <ag-grid-angular style="width: 100%; height: 24vw;" class="ag-theme-alpine"
              [rowData]="selectedBatchInfoRowData" [columnDefs]="selectedBatchInfoColumnDefs"
              (gridReady)="selectedBatchInfoGridReady($event)" [frameworkComponents]="frameworkComponents"
              [gridOptions]="selectedBatchInfoGridOptions" [pagination]="true" [paginationPageSize]="10">
            </ag-grid-angular>
          </mat-card>
        </div>
      </div>
    </mat-card-content>
    <mat-card-content>
      <div class="p-grid p-fluid">
        <div class="p-col-0 p-md-7 p-lg-5">
        </div>
        <div class="p-col-12 p-md-5 p-lg-7">
          <div class="p-grid p-fluid">
            <div class="p-col-6 p-md-7 p-lg-4" style="font-size:end;width: 100%;">
              <form [formGroup]="statusForm">
                <div class="content-top-row ">
                  <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-filed-rem-item">
                    <mat-label class="placeholder-title">{{langObj ? langObj?.Status : ('Status' |
                      translate)}}</mat-label>
                    <mat-select formControlName="status" panelClass="testClass" name="Group"
                      (selectionChange)="changeStatus($event)">
                      <mat-option *ngFor="let status of statusList" [value]="status.TypeId">
                        {{ status?.TypeName }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-filed-rem-item"
                    *ngIf="remarksShowHideProperty" style="width: 65%;">
                    <mat-label class="placeholder-title">{{langObj ? langObj?.Remarks : ('Remarks' |
                      translate)}}</mat-label>
                    <input matInput formControlName="remarks" name="scantBatchNo" />
                  </mat-form-field>
                </div>
              </form>
            </div>
            <div class="p-col-6 p-md-7 p-lg-4" style="text-align: center;">
              <button mat-raised-button color="warn" style="background-color: #0f0fd1;"
                (click)="openPopUpViewForQualityStatus()"><span style="font-size: 12px;color: white;">
                  {{langObj ? langObj?.UpdateStatus : ('UpdateStatus' | translate)}}</span>
              </button>
            </div>
            <div class="p-col-6 p-md-5 p-lg-4" style="text-align: start;">
              <button mat-raised-button color="warn" style="background-color: #0f0fd1;"
                (click)="warehouseHistoryModal()"><span style="font-size: 12px;color: white;">
                  {{langObj ? langObj?.QualityHistory : ('QualityHistory' | translate)}}</span></button>
            </div>
          </div>
        </div>
      </div>

    </mat-card-content>
  </mat-card>

  <!-- Quality History Modal-->
  <ng-template #displayQualityHistoryModal>
    <div mat-dialog-title>
      <div class="d-flex justify-content-between align-items-center" style="font-size: 10px;">
        <h1>Quality Info</h1>
        <button mat-mini-fab mat-button mat-dialog-close color="warn" title="close">
          <i class="fa fa-times" style="color: #fff"></i>
        </button>
      </div>
    </div>
    <div class="p-col-12 p-md-12 p-lg-12">
      <div class="p-grid p-fluid">
        <div class="p-col-1 p-md-6 p-lg-6">
        </div>
        <div class="p-col-11 p-md-6 p-lg-6 m0 p0" style="font-size: 10px;">
        </div>
      </div>
      <div class="content-row-flex-both-end m0 p0">
        <ag-grid-angular class="ag-theme-alpine" style="width: 100%;height: 67.2vh;"
          [columnDefs]="QualityHistoryColumns" [rowData]="qualityHistoryList" [gridOptions]="gridOptions"
          (gridReady)="onGridReady($event)" [pagination]="true"
          [paginationPageSize]="paginationPageSize"></ag-grid-angular>
      </div>
    </div>
  </ng-template>


  <!--Quality Status Modal-->
  <ng-template #displayQualityStatusModal style="padding: 0px;">

    <div mat-dialog-title>
      <div class="d-flex justify-content-between align-items-center" style="font-size: 10px;">
        <h1>Quality Status</h1>
        <button mat-mini-fab mat-button mat-dialog-close color="warn" title="close">
          <i class="fa fa-times" style="color: #fff"></i>
        </button>
      </div>
    </div>
    <div class="notication-icon" style="text-align: center;">
      <div>
        <mat-icon style="font-size: 50px;color: #0f0fd1;" inline="true">notifications</mat-icon>
      </div>
      <div>
        <h4>Are you sure want selected batch <h2>{{ statusType }}</h2>
        </h4>
      </div>
      <hr />
    </div>
    <div style="margin-top: 30px;text-align: end;margin-right: 20px;">
      <button mat-stroked-button mat-dialog-close color="primary" style="font-weight: bold;">No</button>
      <button type="submit" mat-raised-button color="warn" style="background-color: #0f0fd1;margin-left:20px;"
        (click)="SubmitQuality()">Yes</button>
    </div>

  </ng-template>
</div>